import React, { useState } from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import '../../../Static/Master/firmtable.css';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch, useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { deletePI, fetchPurInwardData } from '../../../Store/PHPSlice/Inward/PurchaseInward';
import PreviewIcon from '@mui/icons-material/Preview';
import axios from 'axios';

const TableBody = ({
    serialNumber,
    id,
    pordId,
    piNo,
    poNo,
    dt,
    partyNm,
    firmNm,
    lrdt,
    lrNo,
    transportNm,
    billNo,
    sts_mtr,
    selected,
    handleClick,
}) => {
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const userdata = JSON.parse(localStorage.getItem('user'));
    const dispatch = useDispatch();
    const data = useSelector((state) => state.PurchaseInwardData.deletePurInward);
    // console.log(data);
    const handleDeleteClick = () => {
        // Show confirmation dialog
        const isConfirmed = window.confirm("Are you sure you want to delete this Purchase Inward?");
        // const Ids = {
        //     purId: id,
        //     clothId: clothId,
        //     pInfoId: pInfoId,
        //     pordId: pordId
        // };
        // console.log(Ids);
        // // If user confirms, proceed with deletion
        if (isConfirmed) {
            //     dispatch(deletePI(Ids))
            //         .then(() => {
            //             // Reload the page to show updated results
            //             // toast("Purchase Inward Deleted Sucessfully");
            //             alert("Purchase Inward Deleted Sucessfully");
            //             window.location.reload();
            //         })
            //         .catch((error) => {
            //             // Handle any errors that occur during the deletion process
            //             console.error("Error deleting Item:", error);
            //             toast.error("Failed to delete Item");
            //         });
            handleDeleteAPi(id);
        }


    };

    const handleViewClick = (id) => {
        window.open(`/PIview/${id}`, '_blank', 'width=900,height=600,scrollbars=yes,resizable=yes');
    };

    const handleDeleteAPi = async (id) => {

        try {
            const res = await axios.delete(
                `${baseUrl}?apicall=deletePI_secondAPI&purId=${id}&userId=${userdata?.ID}`
            );
            // console.log(res);
            if (res.data.status === "success") {
                alert(res.data.message);
                // refresh list 
                dispatch(fetchPurInwardData());
                // window.location.reload();

            } else {
                alert(res.data.message);
            }

        } catch (error) {
            console.log(error);
            alert("Error deleting record");
        }

    };

    return (
        <>
            <TableRow hover tabIndex={-1} role="checkbox" selected={selected}>
                {/* <TableCell padding="checkbox">
                    <Checkbox disableRipple checked={selected} onChange={handleClick} />
                </TableCell> */}
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {serialNumber}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {piNo}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {poNo}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {dt}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {partyNm}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {firmNm}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {lrdt}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {lrNo}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {transportNm}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {billNo}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {sts_mtr === '1' ? <button className='sts-btn-updated'>Updated</button> : <button className='sts-btn-pending'>Pending</button>}
                </TableCell>


                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    <PreviewIcon className='cursor-pointer' onClick={() => handleViewClick(id)} />
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    <DeleteIcon className={`cursor-pointer ${sts_mtr === '1' ? 'disabled-icon' : ''}`} onClick={handleDeleteClick} />
                </TableCell>

            </TableRow>
        </>
    );
};

export default React.memo(TableBody);
